import { aadhaarDigits } from '../../shared/utils';

/**
 * Seeds the employee edit form. Every field is a string (or '' for an empty select) so the
 * inputs stay controlled - a null default flips them to uncontrolled on the first keystroke.
 */
export function toEmployeeFormValues(employee: any = {}) {
  return {
    name: employee.name ?? '',
    gender: employee.gender ?? '',
    contact: employee.contact ?? '',
    email: employee.email ?? '',
    designation: employee.designation ?? '',
    departmentId: employee.departmentId ?? '',
    nationality: employee.nationality ?? '',
    medicalCondition: employee.medicalCondition ?? '',
    aadhaarNumber: aadhaarDigits(employee.aadhaarNumber),
    panNumber: employee.panNumber ?? '',
    currentSalary: employee.currentSalary != null ? String(employee.currentSalary) : '',
  };
}

export function calculateEmploymentPeriod(employmentPeriod) {
  if (!employmentPeriod) return null;

  const [startRaw, endRaw] = employmentPeriod.split(' - ');
  const startDate = new Date(startRaw);
  const endDate = endRaw === 'Present' ? new Date() : new Date(endRaw);

  if (Number.isNaN(startDate) || Number.isNaN(endDate)) return null;

  let totalMonths =
    (endDate.getFullYear() - startDate.getFullYear()) * 12 +
    (endDate.getMonth() - startDate.getMonth());

  if (totalMonths < 0) totalMonths = 0;

  return {
    years: Math.floor(totalMonths / 12),
    months: totalMonths % 12,
  };
}

export function calculateEmploymentPeriodFromDates(joiningDate, leavingDate) {
  if (!joiningDate) return null;

  const startDate = new Date(joiningDate);
  const endDate = leavingDate ? new Date(leavingDate) : new Date();

  if (Number.isNaN(startDate) || Number.isNaN(endDate)) return null;

  let totalMonths =
    (endDate.getFullYear() - startDate.getFullYear()) * 12 +
    (endDate.getMonth() - startDate.getMonth());

  if (totalMonths < 0) totalMonths = 0;

  return {
    years: Math.floor(totalMonths / 12),
    months: totalMonths % 12,
  };
}

export function formatEmploymentPeriod(
  period,
  { orientation = 'horizontal', emptyFallback = '—' } = {}
) {
  if (!period) {
    return <span className='unavailable-message'>Not Available</span>;
  }

  const { years, months } = period;

  if (!years && !months) {
    return <span className='unavailable-message'>{emptyFallback}</span>;
  }

  const yearText = years > 0 ? `${years} year${years !== 1 ? 's' : ''}` : null;

  const monthText = months > 0 ? `${months} month${months !== 1 ? 's' : ''}` : null;

  if (orientation === 'horizontal') {
    return [yearText, monthText].filter(Boolean).join(' ');
  }

  return (
    <div>
      {yearText && <div>{yearText}</div>}
      {monthText && <div>{monthText}</div>}
    </div>
  );
}
